module.exports = __webpack_public_path__ + "loading.gif";